module.exports = __webpack_public_path__ + "img/SignPress.cf5b4fe1.png";